<template>
    <div id="allianceend">
        <Header />
        <div class="allianceend_box">
            <div class="container">
                <img src="../assets/images/icon_send.svg" alt="아이콘">
                <p>고객님이 작성하신 문의가<span>정상적으로 접수되었습니다.</span></p>
                <div class="info">
                    <table>
                        <tr>
                            <td>문의자명</td>
                            <td>홍길동</td>
                        </tr>
                        <tr>
                            <td>접수일시</td>
                            <td>2021년 08월 10일</td>
                        </tr>
                        <tr>
                            <td>이메일 주소</td>
                            <td>Testtest6559@artube.com</td>
                        </tr>
                    </table>
                </div>
                <p class="ps">※ 문의주신 내용은 빠른 시간 내에 답변 드리겠습니다.<span>문의한 내용의 결과 회신은 등록해주신 이메일로 발송되오니 확인 부탁드립니다.</span></p>
                <router-link tag="a" to="/">확인</router-link>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer,
    }
}
</script>